import SparkMD5 from 'spark-md5'

export function gbInBytes(gb) {
  return gb * 1024 * 1024 * 1024
}

export function validateFileSize(file, limit) {
  return file.size <= limit
}

export function getMD5Checksum(file) {
  return new Promise((resolve, reject) => {
    const chunkSize = 2097152 // 2MiB
    const nChunks = Math.ceil(file.size / chunkSize)
    let chunkIndex = 0;

    const spark = new SparkMD5.ArrayBuffer()
    const reader = new FileReader()

    const readNextChunk = () => {
      const start = chunkIndex * chunkSize
      const end = Math.min(file.size, start + chunkSize)
      const blob = file.slice(start, end)
      reader.readAsArrayBuffer(blob)
      chunkIndex++
    }

    reader.onload = e => {
      spark.append(e.target.result)

      if (chunkIndex < nChunks) {
        readNextChunk()
      } else {
        resolve(spark.end())
      }
    }

    reader.onerror = e => reject(e)

    readNextChunk()
  })
}



// WEBPACK FOOTER //
// ./src/utils/file.js